module.exports = __webpack_public_path__ + "static/img/feature_2.f5f1bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/feature_2.png
// module id = In9z
// module chunks = 0